module.exports = __webpack_public_path__ + "static/media/Pie_CS.5e3f90a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/reports/assets/Pie_CS.svg
// module id = 287
// module chunks = 0